import { videoMedifileExtenisonsSet } from './const';

export const isVideoMediafile = (extension: string | null | undefined) => {
  if (!extension) {
    return true;
  }

  return videoMedifileExtenisonsSet.has(extension.toLowerCase());
};
